import { Route, Navigate } from "react-router-dom";
import CandidateNotesView from "../views/candidate/dashboard/CandidateNotesView";
import CandidateDashboardPage from "../views/candidate/Dashboard";
import CandidateHomePage from "../views/candidate/dashboard/CandidateHomePage";
import SkillsView from "../views/candidate/dashboard/SkillsView";
import RequestsInfo from "../views/tutor/dashboard/Requests";
import AppointmentsRequestsCandidate from "../views/candidate/dashboard/AppointmentsRequests";
import Congratulation from "../components/Congratulations";
import ActiveChatPage from "../views/chat/ActiveChatPage";
import UnscheduledReaderPage from "../views/candidate/dashboard/UnscheduledReaderPage";
import PaymentPage from "../views/candidate/dashboard/PaymentPage";
import PersonalInfoPage from "../views/candidate/dashboard/personalInfo";
import FillAccountInfoPage from "../views/complete-account/AccountInfo";
import SignUpSuccessfully from "../components/sign-up/SignUpSuccessfully";
import QualifiedPaymentPage from "../views/candidate/qualification/QualifiedPayment";
import ChooseProgram from "../views/candidate/qualification/ChooseProgram";
import useRequireAuth from "../hooks/useRequireAuth";
import CandidateScheduleView from "../views/candidate/qualification/CandidateScheduleView";
import CandidateReadingRoom from "../views/candidate/dashboard/ReadingRoom";

export default function CandidateRouter() {
  const RequireAuth = useRequireAuth();
  return (
    <>
      <Route path="/candidate/dashboard/" element={<CandidateDashboardPage />}>
        <Route
          path="/candidate/dashboard/home"
          element={<CandidateHomePage />}
        />
        <Route
          path="/candidate/dashboard/recitation-notes"
          element={<CandidateNotesView />}
        />
        <Route
          path="/candidate/dashboard/recitation-skills"
          element={<SkillsView />}
        />
        <Route
          path="/candidate/dashboard/requests"
          element={<RequestsInfo />}
        />
        <Route
          path="/candidate/dashboard/appointments-requests"
          element={<AppointmentsRequestsCandidate />}
        />

        <Route
          path="/candidate/dashboard/personal-data"
          element={<PersonalInfoPage />}
        />
        <Route
          path="/candidate/dashboard/payment-subscriptions"
          element={<PaymentPage />}
        />
        <Route
          path="/candidate/dashboard/unscheduled-reader"
          element={<UnscheduledReaderPage />}
        />

        <Route
          path="/candidate/dashboard/change-course"
          element={<div>Change Course</div>}
        />
        <Route
          path="/candidate/dashboard/reading-room-etiquette"
          element={<div>Reading Room Etiquette</div>}
        />
        <Route
          path="/candidate/dashboard/messages"
          element={<ActiveChatPage />}
        />
        <Route
          path="/candidate/dashboard/program-registration"
          element={<Congratulation />}
        />
        <Route
          path="/candidate/dashboard/*"
          element={<Navigate to="/candidate/dashboard/home" />}
        />
        <Route
          path="/candidate/dashboard/"
          element={<Navigate to="/candidate/dashboard/home" />}
        />
      </Route>
      <Route
        path="/candidate/choose-program"
        element={
          <RequireAuth>
            <ChooseProgram />
          </RequireAuth>
        }
      />
      <Route
        path="/candidate/payment-subscriptions"
        element={
          <RequireAuth>
            <QualifiedPaymentPage />
          </RequireAuth>
        }
      />

      <Route
        path="/candidate/schedule"
        element={
          <RequireAuth>
            <CandidateScheduleView />
          </RequireAuth>
        }
      />

      <Route path="/candidate/success-sign" element={<SignUpSuccessfully />} />
      <Route
        path="/candidate/fill-account-info"
        element={<FillAccountInfoPage />}
      />
      <Route
        path="/candidate/dashboard/room/:id"
        element={
          <RequireAuth>
            <CandidateReadingRoom />
          </RequireAuth>
        }
      />
    </>
  );
}
